// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__KG2qG","left":"styles_left__1X907"};